import { z } from "zod";

export const advisoryAgainstSchema = z.object({
  docRejectReason1: z.boolean().default(false),
  docRejectReason2: z.boolean().default(false),
  docRejectDet: z.string().default(""),
});

export type AdvisoryAgainstData = z.infer<typeof advisoryAgainstSchema>;
